import type { Permissions } from 'app/app-state';
import type { DataroomSession } from '../common/services/dataroom';

export const ActionType = Object.freeze({
  CREATE_FOLDER: 'createFolder',
  DRAG_DROP_MOVING: 'dragDropMoving',
  INLINE_EDIT: 'inlineEdit',
  QUICK_DOWNLOAD: 'quickDownload',
  ADD: 'add',
  UPLOAD: 'upload',
  ADD_FOLDER: 'addFolder',
  ADD_DOCUMENT: 'addDocument',
  ADD_FROM_DATAROOM: 'addFromDataRoom',
  BULK_UPLOAD: 'bulkUpload',
  ADD_FROM_FOLDER_STRUCTURE: 'addFromFolderStructure',
  EDIT: 'edit',
  OPEN_IN_OFFICE_ONLINE: 'openInOfficeOnline',
  MOVE: 'move',
  SECURITY: 'security',
  ENABLE_DISABLE: 'enableDisable',
  REDACT_EDIT_REDACT: 'redactOrEditRedact',
  COPY: 'copy',
  DOWNLOAD: 'download',
  ASK_QUESTION: 'askQuestion',
  SECURE_SHARE: 'secureShare',
  COPY_LINK: 'copyLink',
  SEND_TO_KIRA: 'sendToKira',
  HISTORY: 'history',
  NOTIFICATION: 'notification',
  DELETE: 'delete',
  NOTIFICATIONS_REPORT: 'notificationsReport',
});
const defaultDataroomSessionForWidget: Partial<DataroomSession> = {
  allowQnaAttachments: false,
  customWatermarksEnabled: false,
  dataRoomUseSod: false,
  dataRoomUseTermsOfAccess: false,
  documentSecurityEnabled: false,
  fileExtensionAllowOrDeny: '',
  fileExtensionBarDelimitedList: '',
  isAnsaradaSuperUserProfile: false,
  isAnsaradaUserProfile: false,
  isAnsaradaAdminManagementAccessAllowed: false, // For tender submissions
  isDemoDataRoom: false, // For tender submissions
  isUserIpAccessListAllowed: false,
  maxAllowedQuestionLength: 0,
  qnaEnabled: false, // For archive
  qnaWorkflowCode: '',
  sydneyOffsetMinutes: 0, // For archive
  translationTagNameAdminSide: '',
  translationTagNameNonAdminSide: '',
  useSecurity2: false,
  showMyAccount: false,
  userProfileFullName: '',
  userProfileEmail: '', // For archive
  bulkDownloadMaxSizeLimitBytes: 0,
  bulkDownloadMaxItemsCountLimit: 0,
  disableDownloadWhenSavingDenied: false,
  useMultipleSubmissionWindows: false,
  hasFirstGuestUserLoggedIn: false,
  isTenderSubmissionAvailable: false,
  evaluationToolEnabled: false,
};

const unsupportedActionsForDocument: string[] = [
  ActionType.ASK_QUESTION,
  ActionType.COPY_LINK,
  ActionType.COPY,
  ActionType.HISTORY,
  ActionType.MOVE,
  ActionType.NOTIFICATIONS_REPORT,
  ActionType.OPEN_IN_OFFICE_ONLINE,
  ActionType.SECURE_SHARE,
  ActionType.SEND_TO_KIRA,
];

const supportedActionsForDocument: string[] = [
  ActionType.DELETE,
  ActionType.DOWNLOAD,
  ActionType.EDIT,
  ActionType.ENABLE_DISABLE,
  ActionType.INLINE_EDIT,
  ActionType.QUICK_DOWNLOAD,
  ActionType.REDACT_EDIT_REDACT,
];

const unsupportedActionsForFolder: string[] = [
  ActionType.ADD_FROM_DATAROOM,
  ActionType.ADD_FROM_FOLDER_STRUCTURE,
  ActionType.COPY_LINK,
  ActionType.COPY,
  ActionType.HISTORY,
  ActionType.MOVE,
  ActionType.SECURITY,
];

const supportedActionsForFolder: string[] = [
  ActionType.ADD_DOCUMENT,
  ActionType.ADD_FOLDER,
  ActionType.BULK_UPLOAD,
  ActionType.DELETE,
  ActionType.EDIT,
  ActionType.ENABLE_DISABLE,
  ActionType.INLINE_EDIT,
];

const mapPermissionsWithActions: {
  [permission in keyof Permissions]: string[];
} = {
  AllowModifyDocuments: [
    ActionType.ADD_DOCUMENT,
    ActionType.EDIT,
    ActionType.MOVE,
    ActionType.ENABLE_DISABLE,
    ActionType.COPY_LINK,
    ActionType.DELETE,
  ],
  AllowAccessHistory: [ActionType.HISTORY],
  AllowRestoreDocument: [ActionType.NOTIFICATIONS_REPORT],
};

const SMALL_SCREEN_WIDTH = 768;

export {
  defaultDataroomSessionForWidget,
  mapPermissionsWithActions,
  SMALL_SCREEN_WIDTH,
  supportedActionsForDocument,
  supportedActionsForFolder,
  unsupportedActionsForDocument,
  unsupportedActionsForFolder,
};
